"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Empty = function Empty(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      text = _ref.text;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: /*#__PURE__*/(0, _emotion.css)("color:#92999f;padding:2em 2em;height:400px;") + " flex items-center justify-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "center"
  }, typeof icon === 'string' ? /*#__PURE__*/_react.default.createElement("i", {
    "data-test-id": "empty-icon-material-icons",
    className: /*#__PURE__*/(0, _emotion.css)("font-size:5em !important;color:#e0e3e4;") + " material-icons"
  }, icon) : /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "empty-icon-custom-svg",
    className: /*#__PURE__*/(0, _emotion.css)("margin-bottom:-2.25em;> svg,> img{width:180px;height:180px;min-width:180px;min-height:180px;}")
  }, icon), /*#__PURE__*/_react.default.createElement("h3", {
    "data-test-id": "empty-title"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "mb0",
    "data-test-id": "empty-text"
  }, text)));
};

Empty.defaultProps = {
  icon: 'clear',
  title: "No Data Found",
  text: ""
};
Empty.propTypes = {
  icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.object]),
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.object]),
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.object])
};
var _default = Empty;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Empty, "Empty", "/Users/darcy/sites/cs-theme/src/components/empty/index.js");
  reactHotLoader.register(_default, "default", "/Users/darcy/sites/cs-theme/src/components/empty/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();